import { render } from "./PageSoruArsiv.vue?vue&type=template&id=2546b8a4&scoped=true"
import script from "./PageSoruArsiv.vue?vue&type=script&lang=js"
export * from "./PageSoruArsiv.vue?vue&type=script&lang=js"

import "./PageSoruArsiv.vue?vue&type=style&index=0&id=2546b8a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2546b8a4"

export default script